import {
  GET_ORGANIZATION_GROUP_ERROR,
  GET_ORGANIZATION_GROUP_START,
  GET_ORGANIZATION_GROUP_SUCCESS,
} from 'constants/action-types/organizations/getSingleGroup';

export default (state, { type, payload }) => {
  switch (type) {
    case GET_ORGANIZATION_GROUP_START:
      return {
        ...state,
        singleGroup: {
          ...state.singleGroup,
          loading: true,
          error: null,
        },
      };
    case GET_ORGANIZATION_GROUP_SUCCESS:
      return {
        ...state,
        singleGroup: {
          ...state.singleGroup,
          loading: false,
          item: payload.data,
        },
      };
    case GET_ORGANIZATION_GROUP_ERROR:
      return {
        ...state,
        singleGroup: {
          ...state.singleGroup,
          loading: false,
          error: payload,
        },
      };
    default:
      return null;
  }
};
